(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  /*
    Staffelbalk: animatie zoals de cart drawer van Hey Harper.

    theme.js vervangt bij elke wijziging de hele inhoud van
    [data-cart-drawer-inner], dus de balk is na elke update een vers element in
    de eindstand. Dit script zet hem eerst terug in de vorige stand en laat hem
    na 300 ms (dezelfde vertraging als Hey Harper) naar de nieuwe stand lopen:
    de grote pil vult zich, de tekst wisselt, en bereikte treden schuiven naar
    links weg terwijl de grote pil de ruimte overneemt.

    Bij het openen van de drawer start de balk altijd vanaf een lege
    winkelwagen, precies zoals bij Hey Harper: de klant ziet de korting dan
    elke keer opnieuw "binnenkomen".

    Hetzelfde script beheert ook de losse staffelstrook ([data-tier-strip],
    sections/tier-strip.liquid). Die bouwt het hier zelf op met de teksten van
    de schil van deze sectie, en werkt hem bij zodra de drawer opnieuw
    gerenderd wordt, ook als de drawer dicht is. Alles in één script, zodat de
    volgorde waarin Shopify de scripts van secties laadt niet uitmaakt.
  */
  (function () {
    var root = document.getElementById('CartDrawer');
    if (!root) return;
    var inner = root.querySelector('[data-cart-drawer-inner]');
    if (!inner) return;

    var DELAY = 300;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function parse(value) {
      try { return JSON.parse(value) || []; } catch (error) { return []; }
    }

    var enabled = root.getAttribute('data-tier-enabled') === 'true';
    var TITLES = parse(root.getAttribute('data-tier-titles'));
    var SUCCESSES = parse(root.getAttribute('data-tier-successes'));

    function stateFor(count) {
      var reached = Math.min(count, TITLES.length) - 1;
      return {
        label: reached < 0 ? TITLES[0] : SUCCESSES[reached],
        full: count > 0,
        from: Math.max(1, reached + 1),
        showPills: reached < TITLES.length - 1
      };
    }

    /* Natuurlijke breedte van een pil, gemeten zonder overgang. Een pil die
       net uit `is-gone` komt, staat midden in een overgang met padding 0 en
       een smalle max-width; zo'n meting gaf te kleine breedtes, waardoor een
       teruggekomen pil (cart geleegd) half afgeknipt bleef staan. */
    function naturalWidth(pill) {
      var wasGone = pill.classList.contains('is-gone');
      pill.style.transition = 'none';
      pill.classList.remove('is-gone');
      pill.style.maxWidth = 'none';
      var width = pill.getBoundingClientRect().width;
      if (wasGone) pill.classList.add('is-gone');
      pill.style.maxWidth = '';
      void pill.offsetWidth;
      pill.style.transition = '';
      return Math.ceil(width);
    }

    function setPill(pill, show, animate) {
      clearTimeout(pill._pillTimer);
      var shown = !pill.classList.contains('is-gone');
      if (show === shown) {
        pill.style.maxWidth = '';
        return;
      }
      if (!animate) {
        pill.classList.toggle('is-gone', !show);
        pill.style.maxWidth = '';
        return;
      }
      var width = naturalWidth(pill);
      if (show) {
        pill.style.maxWidth = '0px';
        void pill.offsetWidth;
        pill.classList.remove('is-gone');
        pill.style.maxWidth = width + 'px';
      } else {
        pill.style.maxWidth = width + 'px';
        void pill.offsetWidth;
        pill.classList.add('is-gone');
        pill.style.maxWidth = '0px';
      }
      /* Na de overgang de vaste breedte weer loslaten, zodat de pil nooit op
         een oude meting blijft hangen. */
      pill._pillTimer = setTimeout(function () {
        pill.style.maxWidth = '';
      }, 350);
    }

    function apply(bar, state, animate) {
      var main = bar.querySelector('[data-tier-main]');
      var label = bar.querySelector('[data-tier-label]');
      if (!main || !label) return;
      label.textContent = state.label;
      main.style.setProperty('--progress', state.full ? '100%' : '0%');
      main.classList.toggle('is-full', state.full);
      bar.querySelectorAll('[data-tier-pill]').forEach(function (pill) {
        var index = parseInt(pill.getAttribute('data-tier-pill'), 10);
        setPill(pill, state.showPills && index >= state.from, animate);
      });
    }

    /* Zet een balk direct in de stand van `from` en laat hem na DELAY naar
       `to` lopen. Elke balk houdt zijn eigen timer bij. */
    function animate(bar, from, to) {
      if (!bar || !TITLES.length) return;
      clearTimeout(bar._tierTimer);
      if (reduceMotion || from === to) {
        apply(bar, stateFor(to), false);
        return;
      }
      var main = bar.querySelector('[data-tier-main]');
      var animated = [main].concat(Array.prototype.slice.call(bar.querySelectorAll('[data-tier-pill]')));
      animated.forEach(function (element) { if (element) element.style.transition = 'none'; });
      if (main) main.classList.add('is-resetting');
      apply(bar, stateFor(from), false);
      void bar.offsetWidth;
      animated.forEach(function (element) { if (element) element.style.transition = ''; });
      if (main) main.classList.remove('is-resetting');
      bar._tierTimer = setTimeout(function () {
        if (!bar.isConnected) return;
        apply(bar, stateFor(to), true);
      }, DELAY);
    }

    /* Aantal artikelen dat meetelt, uit de laatst gerenderde drawerbalk. Is er
       geen balk, dan is de cart leeg. */
    function currentCount() {
      var bar = inner.querySelector('[data-tier-bar]');
      return bar ? parseInt(bar.getAttribute('data-tier-count'), 10) || 0 : 0;
    }

    /* ---- Losse staffelstrook (sections/tier-strip.liquid) ---- */

    /* Er kunnen meerdere strookjes op een pagina staan: die in de header en
       een op de collectiepagina. Ze lopen allemaal gelijk op. */
    var stripBars = [];
    var stripCount = 0;

    function escapeHtml(text) {
      var span = document.createElement('span');
      span.textContent = text == null ? '' : String(text);
      return span.innerHTML;
    }

    /* Bouwt de strook op. Ook opnieuw aangeroepen wanneer de themabewerker de
       sectie herlaadt, want dan staat er weer een lege knop. */
    function initStrip() {
      var strips = document.querySelectorAll('[data-tier-strip]');
      stripBars = [];
      stripCount = currentCount();
      strips.forEach(function (strip) {
        if (!enabled || !TITLES.length) {
          strip.hidden = true;
          return;
        }
        var pills = '';
        for (var i = 1; i < TITLES.length; i++) {
          pills += '<span class="cart-drawer__tier-pill" aria-hidden="true" data-tier-pill="' + i + '">' +
            escapeHtml(TITLES[i]) + '</span>';
        }
        strip.innerHTML =
          '<span class="cart-drawer__tier-row" data-tier-strip-bar>' +
            '<span class="cart-drawer__tier-main" data-tier-main>' +
              '<span class="cart-drawer__tier-label" data-tier-label></span>' +
            '</span>' + pills +
          '</span>';
        var bar = strip.querySelector('[data-tier-strip-bar]');
        stripBars.push(bar);
        apply(bar, stateFor(0), false);
        if (stripCount > 0) animate(bar, 0, stripCount);

        /* Tikken opent de cart via het bestaande cart-icoon in de header, zodat
           de drawer precies zo opent als anders. */
        if (!strip._tierClick) {
          strip._tierClick = true;
          strip.addEventListener('click', function () {
            var opener = document.querySelector('[data-cart-drawer-open]');
            if (opener) opener.click();
          });
        }
      });
    }

    initStrip();
    document.addEventListener('shopify:section:load', initStrip);

    /* ---- Drawer ---- */

    var previous = currentCount();

    /* Nieuwe inhoud na een wijziging: drawer en strook lopen vanaf de vorige
       stand naar de nieuwe. */
    new MutationObserver(function () {
      var count = currentCount();
      if (root.classList.contains('is-open')) {
        animate(inner.querySelector('[data-tier-bar]'), previous, count);
      }
      if (count !== stripCount) {
        stripBars.forEach(function (bar) { animate(bar, stripCount, count); });
      }
      stripCount = count;
      previous = count;
    }).observe(inner, { childList: true });

    /* Drawer gaat open: altijd vanaf leeg, zoals Hey Harper. */
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        var wasOpen = (record.oldValue || '').split(' ').indexOf('is-open') !== -1;
        var isOpen = root.classList.contains('is-open');
        if (isOpen && !wasOpen) {
          previous = currentCount();
          animate(inner.querySelector('[data-tier-bar]'), 0, previous);
        }
      });
    }).observe(root, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  var KEY = 'theme:recently-viewed';
  var LIMIT = 12;
  var tracked = false;

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function read() {
    try {
      var list = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(list)) return [];
      return list.filter(function (handle) { return typeof handle === 'string' && handle; });
    } catch (error) {
      return [];
    }
  }

  function track(handle) {
    if (tracked || !handle) return;
    tracked = true;
    try {
      window.localStorage.setItem(KEY, JSON.stringify(
        [handle].concat(read().filter(function (item) { return item !== handle; })).slice(0, LIMIT)
      ));
    } catch (error) { /* geblokkeerde opslag: dan geen geschiedenis */ }
  }

  function parseCards(text) {
    return new DOMParser().parseFromString(text, 'text/html').querySelectorAll('.product-card');
  }

  function finish(host, rail, cards) {
    if (!cards.length) return;
    /* In de themabewerker staan er voorbeeldkaarten in de rail; die maken
       plaats zodra de echte producten binnen zijn. */
    rail.querySelectorAll('[data-placeholder-card]').forEach(function (card) {
      card.parentNode.removeChild(card);
    });
    cards.forEach(function (card) { rail.appendChild(card); });
    host.hidden = false;
    /* De carrouselknoppen lazen hun status bij een lege rail; een scroll-tik
       zet prev/next goed nu er kaarten staan. */
    rail.dispatchEvent(new Event('scroll'));
  }

  function fillRecently(host, rail, max) {
    var current = host.getAttribute('data-current-handle') || '';
    var show = read().filter(function (handle) { return handle !== current; }).slice(0, max);
    if (!show.length) return;

    var query = show.map(function (handle) { return 'handle:' + handle; }).join(' OR ');
    fetch(routeRoot() + 'search?type=product&section_id=carousel-cards&q=' + encodeURIComponent(query))
      .then(function (response) { return response.text(); })
      .then(function (text) {
        var byHandle = {};
        parseCards(text).forEach(function (card) {
          var link = card.querySelector('a[href*="/products/"]');
          var match = link && link.getAttribute('href').match(/\/products\/([^\/?#]+)/);
          if (match && !byHandle[match[1]]) byHandle[match[1]] = card;
        });
        /* Zoekresultaten komen niet in kijkvolgorde terug; hier terug in de
           volgorde van localStorage, nieuwste eerst. */
        finish(host, rail, show.map(function (handle) { return byHandle[handle]; }).filter(Boolean));
      })
      .catch(function () { /* geen antwoord is geen fout: blok blijft weg */ });
  }

  function fillRecommended(host, rail, max) {
    var productId = host.getAttribute('data-current-product-id');
    if (!productId) return;

    var url = routeRoot() + 'recommendations/products' +
      '?section_id=carousel-cards' +
      '&product_id=' + encodeURIComponent(productId) +
      '&limit=' + Math.min(max, 10) +
      '&intent=related';

    fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (text) {
        finish(host, rail, Array.prototype.slice.call(parseCards(text)));
      })
      .catch(function () { /* geen antwoord is geen fout: blok blijft weg */ });
  }

  function setup(host) {
    if (host.dataset.sourceReady === 'true') return;
    host.dataset.sourceReady = 'true';

    /* Bijschrijven gebeurt op elke productpagina met een carrousel erop,
       welke bron die ook heeft; zo bouwt de geschiedenis zich overal op. */
    track(host.getAttribute('data-current-handle'));

    var rail = host.querySelector('[data-carousel-rail]');
    if (!rail) return;
    var max = parseInt(host.getAttribute('data-max'), 10) || 8;
    var source = host.getAttribute('data-carousel-source');
    if (source === 'recently') fillRecently(host, rail, max);
    else if (source === 'recommended') fillRecommended(host, rail, max);
  }

  function scan(scope) {
    (scope || document).querySelectorAll('[data-carousel-source]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tier-strip"] && !Shopify.designMode) return;
  try {
    
  /*
    Stapelen van sticky strook en sticky header. Alleen actief als de strook
    op sticky staat. Staat de strook boven de header, dan blijft hij op 0 en
    schuift de header zijn hoogte omlaag; staat hij eronder, dan krijgt de
    strook de hoogte van de header als `top`. Een ResizeObserver houdt dat bij
    wanneer een van beide van hoogte verandert (bijvoorbeeld op mobiel).
  */
  (function () {
    var observers = [];

    function reset(header) {
      observers.forEach(function (o) { o.disconnect(); });
      observers = [];
      if (header) header.style.top = '';
    }

    function watch(elements, update) {
      update();
      if (!window.ResizeObserver) return;
      var observer = new ResizeObserver(update);
      elements.forEach(function (el) { if (el) observer.observe(el); });
      observers.push(observer);
    }

    function init() {
      var header = document.querySelector('.shopify-section--header');
      reset(header);

      /* De strook in de header-groep. */
      var headerStrip = document.querySelector('[data-tier-strip][data-tier-strip-location="header"][data-tier-strip-sticky="true"]');
      var headerWrapper = headerStrip ? headerStrip.closest('.shopify-section') : null;
      if (headerWrapper) {
        watch([headerWrapper, header], function () {
          if (!header) {
            headerWrapper.style.top = '0px';
            return;
          }
          var stripFirst = headerWrapper.compareDocumentPosition(header) & Node.DOCUMENT_POSITION_FOLLOWING;
          if (stripFirst) {
            headerWrapper.style.top = '0px';
            header.style.top = headerWrapper.offsetHeight + 'px';
          } else {
            header.style.top = '';
            headerWrapper.style.top = header.offsetHeight + 'px';
          }
        });
      }

      /* Stroken op een pagina: vlak onder de meelopende header. */
      document.querySelectorAll('[data-tier-strip][data-tier-strip-location="page"][data-tier-strip-sticky="true"]').forEach(function (strip) {
        var wrapper = strip.closest('.shopify-section');
        if (!wrapper) return;
        watch([header, headerWrapper], function () {
          var bottom = 0;
          if (header) bottom = (parseFloat(header.style.top) || 0) + header.offsetHeight;
          if (headerWrapper) {
            var stripFirst = headerWrapper.compareDocumentPosition(header) & Node.DOCUMENT_POSITION_FOLLOWING;
            if (!stripFirst) bottom = (parseFloat(headerWrapper.style.top) || 0) + headerWrapper.offsetHeight;
          }
          wrapper.style.top = bottom + 'px';
        });
      });
    }

    init();
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', function () {
      setTimeout(init, 0);
    });
    document.addEventListener('shopify:section:reorder', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
